import React from "react";
import { Box } from "@mui/material";
import ChatContainer from '@/components/ChatComponent/ChatContainer';

export default function VendorChatInbox() {
    return (
        <Box>
            <ChatContainer />
        </Box>
    );
}
